import React, { useContext } from 'react';
import ReactDOM from 'react-dom/client';
import App from './clients/pages/App';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import ScrollToTop from './clients/utils/ScrollToTop';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import './clients/sass/index.scss';
import HotelList from './clients/pages/HotelList';
import Hotel from './clients/pages/Hotel';
import ResetPassword from './clients/pages/ResetPassword';
import Login from './clients/pages/Login';
import Admin from './adminHotel/pages/Admin';
import Destination from './clients/pages/Destination';
import CreateHotel from './adminHotel/pages/Hotel/CreateHotel';
import { SearchContextProvider } from './clients/utils/SearchContext';
import { AuthContext, AuthContextProvider } from './clients/utils/AuthContext';
import Signup from './clients/pages/Signup';
import LoginAdmin from './adminHotel/pages/LoginAdmin';
import DevAdmin from './devAdmin/pages/Admin';
import EmailVer from './clients/pages/EmailVer';
import Contact from './clients/pages/Contact';
import LoginB from './clients/pages/LoginB_temp';
import RegisterHotel from './clients/pages/RegisterHotel';
import { createTheme, ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import ForgotPassword from './clients/pages/ForgotPassword';
import "./index.css";
import { Toaster } from 'react-hot-toast';
import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import CheckOutPage from './clients/pages/CheckOut/CheckOutPage'
import Confirmation from './clients/pages/CheckOut/Confirmation';
import MyReservations from './clients/pages/User/MyReservations';
import { AuthAdminContext, AuthAdminContextProvider } from './clients/utils/AuthAdminContext';
import Profile from './clients/pages/User/Profil';
import ConfirmReservation from './clients/pages/CheckOut/ConfirmReservation';
import ReservationPending from './clients/pages/CheckOut/Pending';
import { HelmetProvider } from 'react-helmet-async';
import AdminResetPassword from './adminHotel/pages/AdminResetPassword';
import Settings from './clients/pages/User/Settings';
import Favorites from './clients/pages/User/Favorites';


const root = ReactDOM.createRoot(document.getElementById('root'));

function ProtectedUserRoute({ Component }) {
  const { user } = useContext(AuthContext);

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <Component />;
}

function ProtectedAdminRoute({ Component }) {
  const { admin, loading } = useContext(AuthAdminContext);

  // 🔥 pendant vérification du cookie
  if (loading) return null; // ou loader

  // ❌ pas admin → redirection
  if (!admin) {
    return <Navigate to="/admin" replace />;
  }

  // ✅ admin OK
  return <Component/>;
}


const theme = createTheme({
  palette: {
    primary: {
      main: '#3A9D23',
    },
  },
});

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <ScrollToTop />

      <AuthContextProvider>
          <AuthAdminContextProvider>
            <SearchContextProvider>

              <ThemeProvider theme={theme}>
                <MantineProvider
                  theme={{
                    primaryColor: "green",
                    colors: {
                      green: [
                        "#e9f7ec",
                        "#d2efda",
                        "#a6dfb4",
                        "#79cf8f",
                        "#4cbf69",
                        "#3A9D23",
                        "#2f7f1c",
                        "#256015",
                        "#1b420e",
                        "#112507"
                      ]
                    },
                    defaultRadius: "md",
                    fontFamily: "Inter, sans-serif"
                  }}
                >

                  <CssBaseline />
                  <Toaster position="top-right" />

                  <Routes>
                    <Route path="/" element={<App />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/hotels" element={<HotelList />} />
                    <Route path="/destinations" element={<Destination />} />                   
                    <Route path="/hotel/slug/:slug" element={<Hotel />} />
                    <Route path="/register-hotel" element={<RegisterHotel />} />                  
                    <Route path="/checkout" element={<CheckOutPage/>} />
                    <Route path="/confirmation/:id" element={<Confirmation/>} />
                    <Route path="/reservation-pending" element={<ReservationPending />} />
                    <Route path="/confirm-reservation" element={<ConfirmReservation />} />
                    <Route path="/my-reservations" element={<MyReservations/>} />
                    <Route path="/profile" element={<Profile/>} />
                    <Route path="/settings" element={<Settings/>} />
                    <Route path="/favorites" element={<Favorites/>} />



                    <Route path="/login" element={<Login />} />
                    <Route path="/login/:userId" element={<LoginB />} />

                    <Route
                      path="/profile"
                      element={<ProtectedUserRoute />}
                    />

                    

                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password/:token" element={<ResetPassword />} />

                    <Route path="/admin" element={<LoginAdmin />} />
                    <Route path="/admin-reset/:token" element={<AdminResetPassword />} />

                    <Route path="/signup" element={<Signup />} />
                    <Route path="/signup/emailverification" element={<EmailVer />} />

                    <Route path="/admin/:userId" element={<ProtectedAdminRoute Component={CreateHotel} />} />
                    <Route path="/admin/:userId/:hotelId" element={<ProtectedAdminRoute Component={Admin} />} />
                    <Route path="/devAdmin/:id" element={<ProtectedAdminRoute Component={DevAdmin} />} />

                  </Routes>

                </MantineProvider>
              </ThemeProvider>

            </SearchContextProvider>
        </AuthAdminContextProvider>
      </AuthContextProvider>

    </BrowserRouter>
  </HelmetProvider>
);

reportWebVitals();
